import { Directive, ElementRef, Input, Renderer2, AfterViewInit } from '@angular/core';
import { BannerStatusConfig } from 'src/app/_utils/_directives/_models/banner-status-config';
import { ProyectosHomeService } from 'src/app/home/_services/proyectos-home.service';

@Directive({
  selector: '[bannerStatus]',
  standalone: true,
  providers: []
})
export class BannerStatusDirective implements AfterViewInit {
  @Input() bannerStatusConfig: BannerStatusConfig; 
  title: string = "NUEVA OPORTUNIDAD";
  isLoading: boolean = false;

  constructor (
        private _el: ElementRef,
        private _renderer: Renderer2, 
        private _homeService: ProyectosHomeService,
    ) {

    }

  ngAfterViewInit() {
    this._renderer.setProperty(this._el.nativeElement, 'innerText', this.title);
    // Utilizamos el getProyectoById porque trae menos datos y es más rápido
    switch(this.bannerStatusConfig.plataforma){
        case 'VENTURE':
            this.getProyectoVenture(this.bannerStatusConfig.proyectoId);
            break;
        case 'REALESTATE':
            this.getProyectoRealEstate(this.bannerStatusConfig.proyectoId);
            break;
        case 'CREATIVE':
            this.getProyectoAudiovisual(this.bannerStatusConfig.proyectoId);
            break;
        default:
            break;
    }
  }

  private getProyectoVenture(id: number){
    this.isLoading = true;
    this._homeService.getProyectoVenture(id).subscribe({
        next: (proyecto) => {
            this.isLoading = false;
            const porcientoFinanciado = proyecto.porcientoFinanciado;
            if(porcientoFinanciado >= 50 && porcientoFinanciado < 80){
                this.title = '50% FINANCIADO';
            }
            else if(porcientoFinanciado >= 80) {
                this.title = '80% FINANCIADO';
            }
        },
        complete: () => {
            this.isLoading = false;
            this._renderer.setProperty(this._el.nativeElement, 'innerText', this.title);
        },
        error: (error) => {
            console.error(`ERROR ${error.status}: ${error.statusText}`);
        }
    });
  }

  private getProyectoRealEstate(id: number){
    this.isLoading = true;
    this._homeService.getProyectoRealEstate(id).subscribe({
        next: (proyecto) => {
            this.isLoading = false;
            const porcientoFinanciado = proyecto.porcientoFinanciado;
            if(porcientoFinanciado >= 50 && porcientoFinanciado < 80){
                this.title = '50% Financiado';
            }
            else if(porcientoFinanciado >= 80) {
                this.title = '80% Financiado';
            }
        },
        complete: () => {
            this._renderer.setProperty(this._el.nativeElement, 'innerText', this.title);
        },
        error: (error) => {
            this.isLoading = false;
            console.error(`ERROR ${error.status}: ${error.statusText}`);
        }
    });
  }

  private getProyectoAudiovisual(id: number){
    this.isLoading = true;
    this._homeService.getProyectoAudiovisual(id).subscribe({
        next: (proyecto) => {
            this.isLoading = false;
            const porcientoFinanciado = proyecto.porcentajeFinanciado;
            if(porcientoFinanciado >= 50 && porcientoFinanciado < 80){
                this.title = '50% Financiado';
            }
            else if(porcientoFinanciado >= 80) {
                this.title = '80% Financiado';
            }
        },
        complete: () => {
            this._renderer.setProperty(this._el.nativeElement, 'innerText', this.title);
        },
        error: (error) => {
            this.isLoading = false;
            console.error(`ERROR ${error.status}: ${error.statusText}`);
        }
    });
  }
}